import React, { useState, useCallback } from 'react';
import GoogleMapComponent from './GoogleMapComponent';

const MapTestPage = () => {
  const [mapInstance, setMapInstance] = useState(null);
  const [center, setCenter] = useState({ lat: 37.7749, lng: -122.4194 });
  const [zoom, setZoom] = useState(12);

  const handleMapLoad = useCallback((map) => {
    setMapInstance(map);
    console.log('Map loaded successfully:', map);
  }, []);

  const testLocations = [
    { name: 'San Francisco', lat: 37.7749, lng: -122.4194 },
    { name: 'New York', lat: 40.7128, lng: -74.0060 },
    { name: 'Washington DC', lat: 38.9072, lng: -77.0369 },
    { name: 'London', lat: 51.5074, lng: -0.1278 },
    { name: 'Tokyo', lat: 35.6762, lng: 139.6503 }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
          Google Maps Component Test
        </h1>
        
        {/* Controls */}
        <div className="bg-white dark:bg-gray-800 rounded-lg p-4 mb-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Quick Navigation
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            {testLocations.map((location) => (
              <button
                key={location.name}
                onClick={() => setCenter({ lat: location.lat, lng: location.lng })}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
              >
                Go to {location.name}
              </button>
            ))}
          </div>
          
          <div className="mt-4 flex items-center space-x-4">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Zoom:
            </label>
            <input
              type="range"
              min="1"
              max="20"
              value={zoom}
              onChange={(e) => setZoom(parseInt(e.target.value))}
              className="flex-1 max-w-xs"
            />
            <span className="text-sm text-gray-600 dark:text-gray-400">
              {zoom}
            </span>
          </div>
        </div>

        {/* Map Container */}
        <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Map Display
          </h2>
          
          <div className="h-96 md:h-[500px] lg:h-[600px]">
            <GoogleMapComponent
              center={center}
              zoom={zoom}
              onMapLoad={handleMapLoad}
              showUserMarker={true}
              className="w-full h-full rounded-lg border border-gray-200 dark:border-gray-700"
            />
          </div>
          
          {/* Map Info */}
          <div className="mt-4 text-sm text-gray-600 dark:text-gray-400">
            <p>Center: {center.lat.toFixed(4)}, {center.lng.toFixed(4)}</p>
            <p>Zoom: {zoom}</p>
            <p>Map Instance: {mapInstance ? 'Loaded' : 'Not loaded'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapTestPage;